import React from 'react';
import { Box, Button, Grid, MenuItem, Paper, Select } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import ExcelToJsonComponent from '../../components/shared/ExcelToJsonComponent';
import { DataGrid } from '@mui/x-data-grid';
// import { esES } from '@mui/x-data-grid/locales';
import { feathersCreateData } from '../../services';
import './../../styles/DataGridStyles.css';
import SendPayrollForm from '../../components/Payrolls/SendPayrollForm';
import { getDeviceInfo } from '../../services/devices';
import { decrypt, encrypt, sendMobile } from '../../functions/mobile';
import LoadingScreen from '../../components/Complements/LoadingScreen';
import { isEmpty } from '../../functions/arrays';
// import { ArrowBackIos } from '@material-ui/icons';
import { ipFront } from '../../services/urls';
import { history } from '../../helpers/history';
import DialogOTP from '../../components/Complements/DialogOTP';
import { useSelector } from 'react-redux';
const SendPayRoleComponent = ({ accountList = [], handleOpenSnack }) => {
  const [selectedAccount, setSelectedAccount] = useState(
    accountList[0] || ''
  );
  // const theme = useTheme();
  const [dataJson, setDataJson] = useState([]);
  const [dataTotal, setDataTotal] = useState(0);
  const [dataConcept, setDataConcept] = useState('');
  const [openDialogOTP, setOpenDialogOTP] = useState(false);
  const [payrollWhitError, setPayrollWhitError] = useState(false);
  const [initialTime, setInitialTime] = useState(Date.now());
  // const [lengthToken, setLengthToken] = useState(4);
  const [timeLifeToken, setTimeLifeToken] = useState(180000);
  const permissions = useSelector(state => state.permissions)
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 10,
  });


  useEffect(() => {
    if (accountList && accountList[0]) {
      setSelectedAccount(accountList[0]);
      //console.log('los permisos son',permissions)
    }
    // eslint-disable-next-line
  }, []);

  const handleChange = (event) => {
    setSelectedAccount(event.target.value);
  };
  const handleCloseDialogOTP = () => {
    setOpenDialogOTP(false);
    setLoading(false);
  };
  const [loading, setLoading] = useState(false);


  const columns = [
    {
      field: 'Identificacion',
      headerName: 'Identificación',
      flex: 1,
      sortable: false,
    },
    {
      field: 'TipoIdentificacion',
      headerName: 'Tipo Identificación',
      flex: 1,
      sortable: false,
    },
    {
      field: 'NombreApellido',
      headerName: 'Nombres',
      flex: 1,
      sortable: false,
    },
    {
      field: 'NumeroCuentaDestino',
      headerName: 'Cuenta destino',
      flex: 1,
      sortable: false,
      // valueGetter: (params) => maskDataKeepFirstLast2(params.row.NumeroCuentaDestino),
    },
    {
      field: 'Institucion',
      headerName: 'Institución',
      flex: 1,
      sortable: false,
      valueGetter: (params) => params.row.Institucion.trim(),
    },
    {
      field: 'TipoCuenta',
      headerName: 'Tipo Cuenta',
      flex: 1,
      sortable: false,
    },
    {
      field: 'Valor',
      headerName: 'Valor',
      flex: 1,
      sortable: false,
    },

    {
      field: 'itsOk',
      headerName: 'Validación',
      renderCell: (params) => {
        const { value, row } = params;

        let descriptions = [];

        const raw = row.descriptions;

        if (Array.isArray(raw)) {
          descriptions = raw;
        } else if (typeof raw === 'string') {
          try {
            // 1. Intenta parsear como JSON (con comillas simples convertidas a dobles)
            const fixed = raw.replace(/'/g, '"');
            const parsed = JSON.parse(fixed);
            if (Array.isArray(parsed)) {
              descriptions = parsed;
            } else {
              // 2. Si no es un array, intenta dividir manualmente por patrones comunes
              descriptions = fixed.split(/(?=[A-Z])/).map(s => s.trim());
            }
          } catch (e) {
            // 3. Si todo falla, divide el string por palabras con mayúsculas (ej: "CuentaDestinoRepetidaIdentificación...")
            descriptions = raw.split(/(?=[A-Z])/).map(s => s.trim());
          }
        }

        return (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              whiteSpace: 'normal',
              wordBreak: 'break-word',
              lineHeight: '1.3',
              overflow: 'visible',
            }}
          >
            {value === 'INCORRECTO' ? (
              <div style={{ color: 'red', fontSize: '0.7rem' }}>
                {descriptions.join(', ')} {/* Mostrar las descripciones en rojo */}
              </div>
            ) : (
              <b style={{ color: 'green', fontSize: '0.9rem' }}>{value}</b> // Mostrar "CORRECTO" en verde
            )}
          </div>
        );
      },
      flex: 1,
      sortable: false,
    }
  ];

  const renderDataJson = () => (
    <Box style={{ width: '100%' }}>

      <DataGrid
        autoHeight
        rows={dataJson}
        columns={columns}
        pageSize={10}
        pageSizeOptions={[10, 25, 50]}
        paginationModel={paginationModel}
        onPaginationModelChange={setPaginationModel}
        getRowHeight={() => 'auto'}
        isRowSelectable={() => false}
        sx={{
          '& .MuiDataGrid-cell': {
            whiteSpace: 'normal',
            wordBreak: 'break-word',
            lineHeight: '1.3',
            alignItems: 'start',
          },
        }}
        localeText={{
            columnsPanelShowAllButton: 'Show all', // ocultamos el texto "Show all"
            columnsPanelHideAllButton: '', // ocultamos el texto "Hide all"
        }}
      />

    </Box>
  );
  const handleChangeInputOtp = (valueInputOtp) => {
    if (valueInputOtp.toString().length === 6) {
      receiveOTP({ data: valueInputOtp.toString() });
    }
  };


  const onKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      ev.preventDefault()
    } else {
      if (ev.target.value.toString().length === 6) {
        receiveOTP({ data: ev.target.value });
      }

    }
  }

  const handleDownloadFileXLSX = () => {
    if (isMobile) {
      sendMobile(JSON.stringify({
        type: 'openLink',
        data: ipFront + 'plantillaNomina.xlsx'
      }));
    } else {
      const fileURL = '/plantillaNomina.xlsx'; // Ruta desde la carpeta public
      window.open(fileURL, '_blank'); // Abre el archivo en una nueva pestaña
      // setAnchorEl(null);
    }
  };

  const receiveOTP = async (value) => {
    try {
      setLoading(true);
      let resultDevice = {};
      const deviceInfo = await getDeviceInfo(null);
      //console.log('deviceInfo', deviceInfo);
      resultDevice = deviceInfo.data;
      const { ip, device, mac } = resultDevice;

      const sendData = encrypt(JSON.stringify({
        ip,
        mac,
        device,
        type: 25,
        inputOtp: value.data,
      }));

      const responseValidateCode = await feathersCreateData('code-validation', { sendData })();

      console.log('Respuesta: ', responseValidateCode);

      const { error, message, type, viewDialogOtp } = responseValidateCode;

      if (error === false) {
        handleCloseDialogOTP();
        uploadPayrollProcess(value.data)
      } else {
        if (viewDialogOtp === false) {
          handleCloseDialogOTP();
        }
        handleOpenSnack(message, type);
        setLoading(false);
      }
    } catch (error) {
    }
  }

  const uploadPayrollProcess = async (otp) => {
    try {
      setLoading(true);
      const deviceInfo = await getDeviceInfo(null);
      // const { ip, device, mac } = deviceInfo;
      feathersCreateData('payrolls-control', {
        service: 'CREATE_ROLL',
        nomina: dataJson,
        ...deviceInfo.data,
        otp,
        totalAmount: dataTotal,
        accountSequential: selectedAccount.PRODUCTBANKID,
        originAccount: selectedAccount.PRODUCTBANKID,
        nombreCuenta: selectedAccount.PRODUCTALIAS,
        concept: dataConcept
      })().then(async res => {
        const { error } = res
        if (error) {
          handleOpenSnack(res.message, 'error');
        } else {
          //aqui
          setLoading(true);
          handleOpenSnack(res.message, 'success');
          // Espera 6 segundos antes de redirigir
          await new Promise(resolve => setTimeout(resolve, 6000));
          // SI EL USUARIO NO TIENE EL PERMISO DE CONSULTAR NOMINA, SE LE DIRIGE AL ESTADO DE CUENTA
          if (permissions?.includes(10)) {
            history.push('/activityPayRole');
          } else {
            history.push('/');
          }

        }
        setLoading(false);
      }).catch(err => {
        setLoading(false);
      })
    } catch (error) {
      setLoading(false);
    }
  }
  const getDataValidation = async (data) => {
    try {
      if (isEmpty(selectedAccount)) {
        handleOpenSnack('Seleccione una cuenta', 'error')
      } else {
        setLoading(true)
        await feathersCreateData('payrolls-control', {
          service: 'DATA_VALIDATE',
          payrollsData: data,
          selectedAccount
        })().then(res => {
          setLoading(false)
          const { data: payrolls, total, error, message, type, payrollWhitError } = res
          //console.log('la respuesta de la nomina es',res)
          if (error) {
            handleOpenSnack(message, type)
            //setPayrollWhitError(payrollWhitError)
          } else {
            setDataJson(payrolls);
            setPayrollWhitError(payrollWhitError)
            setDataTotal(total)
          }
        }).catch(err => { setLoading(false); return err })
      }

    } catch (error) {
    }
  }

  const sendDatatoPayroll = (dataForm) => {
    try {
      if (isEmpty(selectedAccount)) {
        handleOpenSnack('Seleccione una cuenta', 'error')
      } else {
        if (payrollWhitError) {
          handleOpenSnack('La Nómina presenta errores', 'error')
        } else {
          setDataConcept(dataForm.description)
          requestOtp()
        }
      }
    } catch (error) {
    }
  }
  const requestOtp = async () => {
    try {
      let resultDevice = {};
      let values = {}
      setLoading(true);
      const deviceInfo = await getDeviceInfo(null);
      //console.log('deviceInfo', deviceInfo);

      resultDevice = deviceInfo.data;
      const { ip, device, mac } = resultDevice;
      values.ip = ip;
      values.mac = mac;
      values.device = device;
      const sendData = encrypt(JSON.stringify({ emited: 'NAVCREATECODE', values, type: 25, deviceData: device, ip, mac }));

      const responseCode = await feathersCreateData('codes-recovery', { sendData })();
      const jsonDecrypt = JSON.parse(decrypt(responseCode.responseData));
      const { type, result, timeLifeToken } = jsonDecrypt;
      if (type === 'success') {
        // setValuesLogin(values);
        //handleOpenSnack(result, type)
        setInitialTime(Date.now());
        setOpenDialogOTP(true);
        setLoading(false);

        setTimeLifeToken(timeLifeToken);
      } else {
        setLoading(false);
        handleOpenSnack(result, type);
      }
    } catch (error) {

    }
  };


  const renderBody = () => (
    <Paper elevation={0} display="flex" flex={1} flexDirection="column" style={{ margin: '16px', borderRadius: '16px' }}>
      <Box
        display="flex"
        flexDirection="column"
        borderRadius="20px"
        // bgcolor={theme.palette.secondary.main}
        padding={1.5}
      >
        <Grid container spacing={2}>

          <Grid item xs={12} sm={6}>
            <Select
              fullWidth
              label="Cuentas"
              labelId="demo-simple-select-label"
              id="entity"
              value={selectedAccount}
              onChange={handleChange}
            >
              {accountList.map((option) => (
                <MenuItem
                  key={`${option.PRODUCTBANKID}_account`}
                  value={option}
                >{`${option.PRODUCTBANKID || ''} - ${option.PRODUCTALIAS || ''
                  }`}</MenuItem>
              ))}
            </Select>
          </Grid>

          {/* ExcelToJsonComponent */}
          <Grid item xs={12} sm={3}>
            <ExcelToJsonComponent
              onLoadJson={(json) => {
                getDataValidation(json);
              }}
            />
          </Grid>

          {/* Download Button */}
          <Grid item xs={12} sm={3}>
            <Button variant='outlined' color='primary' onClick={handleDownloadFileXLSX} fullWidth>
              Descargar Plantilla
            </Button>
          </Grid>
        </Grid>
      </Box>

      <Box flex={1} mt={3}>
        {dataJson.some((item) => item) && (
          <SendPayrollForm onSubmit={sendDatatoPayroll} dataTotal={dataTotal}>
            {renderDataJson()}
          </SendPayrollForm>
        )}
      </Box>
    </Paper>
  );

  return (
    <>
      {renderBody()}

      <DialogOTP
        openDialogOTP={openDialogOTP}
        onCloseDialogOTP={() => setOpenDialogOTP(false)}
        initialTime={initialTime}
        loading={loading}
        showQR={false}
        OTPSubmit={receiveOTP}
        handleChangeInputOtp={handleChangeInputOtp}
        onKeyPress={onKeyPress}
        timeLifeToken={timeLifeToken}
      />
      <LoadingScreen
        open={loading}
      />
    </>
  );
};
SendPayRoleComponent.propTypes = {
  handleLogOut: PropTypes.func.isRequired,
  accountList: PropTypes.array.isRequired,
};

export default SendPayRoleComponent;
